import { Navigate } from 'react-router'
import { useAuth } from '~/api/auth'

const RequireGuest = (props) => {
  const { children } = props
  const { render } = useAuth({ middleware: 'guest' })
  return render(<Navigate to="/" replace />, children)
}

export default RequireGuest
